import { ChangeEvent } from 'react';
import Form from 'react-bootstrap/Form';
import { formatarMoeda } from '../utils/formatadores';

interface MoedaInputProps {
  label?: string;
  value: number | string | undefined;
  onValueChange: (valor: number) => void;
  required?: boolean;
  disabled?: boolean;
}

export function MoedaInput({ label, value, onValueChange, required, disabled }: MoedaInputProps) {
  const valorNumerico = typeof value === 'number' ? value : Number(value) || 0;

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const digitos = event.target.value.replace(/\D/g, '');
    const numero = digitos ? Number(digitos) / 100 : 0;
    onValueChange(numero);
  }

  return (
    <Form.Group className="mb-3">
      {label && <Form.Label className="lizzi-form-label">{label}</Form.Label>}
      <Form.Control
        className="lizzi-form-control"
        inputMode="numeric"
        value={formatarMoeda(valorNumerico)}
        onChange={handleChange}
        required={required}
        disabled={disabled}
      />
    </Form.Group>
  );
}
